import client from '@/api/client'
import { withErrorHandling } from '@/utils/errors'

export interface AuthorizeUserRequest {
  email: string
  password: string
}

export interface AuthorizeUserResponse {
  accessToken: string
  refreshToken: string
  userData: {
    id: string
    email: string
    name: string
  }
}

export interface RefreshTokenRequest {
  refresh_token: string
}

export interface RefreshTokenResponse {
  access_token: string
}

export const authorize = withErrorHandling(
  async (credentials: AuthorizeUserRequest) => {
    return client.POST('/v1/authorize', {
      body: credentials,
    })
  },
)

export const authRefresh = withErrorHandling(
  async (refresh_token: string) => {
    return client.POST('/v1/authorize/refresh', {
      body: {
        refresh_token,
      } as RefreshTokenRequest,
    })
  },
)

export const getUserProviders = withErrorHandling(async () => {
  return client.GET('/v1/user/providers')
})

export const getCurrentProvider = withErrorHandling(async () => {
  return client.GET('/v1/provider')
})

export const switchUserProvider = withErrorHandling(
  async (providerId: string) => {
    return client.POST('/v1/user/providers/switch', {
      body: { providerId },
    })
  },
)
